// import React, { useEffect, useState, useCallback } from "react";
// import "../assets/transactions/TransactionReport.css";
// import axios from "axios";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// const API_URL = "https://payyug.in/api";

// const TransactionReport = () => {
//   const dispatch = useDispatch();
//   const { profile } = useSelector((state) => state.userProfile);

//   /* ================= STATES ================= */
//   const [savingAccounts, setSavingAccounts] = useState([]);
//   const [selectedAccount, setSelectedAccount] = useState(null);
//   const [transactions, setTransactions] = useState([]);

// //   const [fromDate, setFromDate] = useState("");
// //   const [toDate, setToDate] = useState("");

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   /* ================= FETCH PROFILE ================= */
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   /* ================= FETCH SAVING ACCOUNTS ================= */
//   useEffect(() => {
//     if (!profile) return;

//     const fetchSavingAccounts = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-all-saving-account`, {
//           params: {
//             superAdminId: profile.superAdminId,
//             branchId: profile.branchId,
//             createdBy: localStorage.getItem("userId"),
//           },
//         });

//         setSavingAccounts(res.data?.accounts || []);
//       } catch (err) {
//         alert("Failed to fetch saving accounts");
//       }
//     };

//     fetchSavingAccounts();
//   }, [profile]);

//   /* ================= FETCH TRANSACTIONS ================= */
//   const fetchTransactions = useCallback(async () => {
//     if (!profile || !selectedAccount) return;

//     try {
//       setLoading(true);
//       setError("");

//       const res = await axios.get(
//         `${API_URL}/all-saving-account/transaction-all`,
//         {
//           params: {
//             // superAdminId: profile.superAdminId,
//             // branchId: profile.branchId,
//             accountId: selectedAccount.id,
//             // fromDate,
//             // toDate,
//           }
//         }
//       );

//       setTransactions(res.data?.statement || []);
//     } catch (err) {
//       setError(err?.response?.data?.message || "Failed to fetch transactions");
//     } finally {
//       setLoading(false);
//     }
//   }, [profile, selectedAccount]);

//   /* ================= SUBMIT ================= */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!selectedAccount) {
//       alert("Please select Saving Account");
//       return;
//     }

//     // if (!fromDate || !toDate) {
//     //   alert("Please select From Date and To Date");
//     //   return;
//     // }

//     await fetchTransactions();
//   };

//   return (
//     <div className="transaction-report-container">
//       <h1 className="transaction-report-heading">Transaction Report</h1>

//       {/* ================= FILTER ================= */}
//       <div className="transaction-report-filter-container">
//       <form className="transaction-report-filter-form" onSubmit={handleSubmit}>
//         <div className="transaction-report-filter-form-section">
//           <div className="transaction-report-filter-form-input-fields">
//             <label>Saving Account</label>
//             <select
//               value={selectedAccount?.id || ""}
//               onChange={(e) => {
//                 const acc = savingAccounts.find(
//                   (a) => a.id === Number(e.target.value)
//                 );
//                 setSelectedAccount(acc || null);
//               }}
//             >
//               <option value="">Select Account</option>
//               {savingAccounts.map((acc) => (
//                 <option key={acc.id} value={acc.id}>
//                   {acc.customerName} | {acc.accountNumber}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* <div className="transaction-report-filter-form-input-fields">
//             <label>From Date</label>
//             <input
//               type="date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//             />
//           </div>

//           <div className="transaction-report-filter-form-input-fields">
//             <label>To Date</label>
//             <input
//               type="date"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//             />
//           </div> */}
//         </div>

//         <div className="transaction-report-filter-form-submit-btn">
//           <button type="submit" disabled={loading}>
//             {loading ? "Loading..." : "Get Records"}
//           </button>
//         </div>
//       </form>
//       </div>

//       {/* ================= TABLE ================= */}
//       <div className="transaction-report-table-container">
//         {error && <p className="error-text">{error}</p>}

//         <table className="transaction-report-table">
//           <thead>
//             <tr>
//               <th>SN</th>
//               {/* <th>Saving Account ID</th> */}
//               <th>Customer ID</th>
//               <th>Txn Type</th>
//               <th>Amount</th>
//               <th>Payment Mode</th>
//               <th>Balance After Txn</th>
//               <th>Date</th>
//               <th>Remarks</th>
//               <th>Status</th>
//             </tr>
//           </thead>

//           <tbody>
//             {transactions.length > 0 ? (
//               transactions.map((item, index) => (
//                 <tr key={item.id}>
//                   <td>{index + 1}</td>
//                     {/* <td>{selectedAccount?.id}</td> */}
//                   <td>{item.customerId}</td>
//                   <td>{item.txnType}</td>
//                   <td>{item.amount}</td>
//                   <td>{item.paymentMode}</td>
//                   <td>{item.balanceAfterTxn}</td>
//                   <td>
//                     {item.txnDate
//                       ? new Date(item.txnDate).toLocaleString()
//                       : "-"}
//                   </td>
//                   <td>{item.remarks || "-"}</td>
//                   <td>{item.status}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="10" style={{ textAlign: "center" }}>
//                   {loading ? "Loading..." : "No records found"}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default TransactionReport;

import React, { useEffect, useState, useCallback } from "react";
import Select from "react-select";
import "../assets/transactions/TransactionReport.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const TransactionReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profile } = useSelector((state) => state.userProfile);

  /* ================= STATES ================= */
  const [savingAccounts, setSavingAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [accountType, setAccountType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [company, setCompany] = useState(null);
  const [branch, setBranch] = useState(null);

  /* ================= FETCH PROFILE ================= */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // Fetch Company Detail
  useEffect(() => {
    const fetchCompany = async () => {
      if (!profile?.superAdminId) return;

      try {
        const res = await axios.get(`${API_URL}/get-company`, {
          params: {
            superAdminId: profile.superAdminId,
          },
        });

        const data = res.data;

        if (data?.logo) {
          data.logoUrl = `https://payyug.in/${data.logo.replace(
            /^images\//,
            "",
          )}`;
        }

        // console.log("Company details:", data);
        setCompany(data);
      } catch (err) {
        console.error("Company fetch error:", err);
      }
    };

    fetchCompany();
  }, [profile?.superAdminId]);

  // Fetch Branch Details
  useEffect(() => {
    const fetchBranch = async () => {
      if (!profile?.branchId) return;

      try {
        const res = await axios.get(`${API_URL}/get-byId/${profile.branchId}`);

        // console.log("Branch details:", res.data);
        setBranch(res.data);
      } catch (err) {
        console.error("Branch fetch error:", err);
      }
    };

    fetchBranch();
  }, [profile?.branchId]);

  /* ================= FETCH SAVING ACCOUNTS ================= */

  const fetchSavingAccounts = async () => {
    try {
      const res = await axios.get(`${API_URL}/get-all-saving-account`, {
        params: {
          superAdminId: profile.superAdminId,
          branchId: profile.branchId,
          createdBy: localStorage.getItem("userId"),
        },
      });

      setSavingAccounts(res.data?.accounts ?? []);
    } catch (err) {
      console.error("Saving account fetch error:", err);
      setSavingAccounts([]);
    }
  };

  const fetchAccounts = async () => {
    try {
      const superAdminId = profile.superAdminId || 14;
      const branchId = localStorage.getItem("userId") || 56;

      const res = await axios.get("https://payyug.in/api/deposit/list", {
        params: {
          superAdminId,
          branchId,
        },
      });
      if (res.data.success) {
        setSavingAccounts(res.data.data || []);
      } else {
        setSavingAccounts([]);
      }
    } catch (err) {
      console.error("Error fetching deposit accounts:", err);
      setSavingAccounts([]);
    }
  };

  //mis acccount
  const fetchMisAccounts = async () => {
    try {
      const superAdminId = profile.superAdminId || 14;
      const branchId = localStorage.getItem("userId") || 56;

      const res = await axios.get("https://payyug.in/api/fdmis/all-new", {
        params: {
          superAdminId,
          branchId:profile?.branchId,
           createdBy:branchId,
           limit:1000,
          accountType: accountType,
        },
      });
      console.log("fdmis",res.data)
      if (res.data.success) {
        setSavingAccounts(res.data.data || []);
      } else {
        setSavingAccounts([]);
      }
    } catch (err) {
      console.error("Error fetching deposit accounts:", err);
      setSavingAccounts([]);
    }
  };

  useEffect(() => {
    if (!profile?.superAdminId || !profile?.branchId || !accountType) return;

    const fetchData = async () => {
      setLoading(true); // Always good to trigger loading
      try {
        switch (accountType) {
          case "SAVING":
            await fetchSavingAccounts();
            break;
          case "MIS":
            await fetchMisAccounts();
            break;
          case "RD":
          case "DD":
          default:
            await fetchAccounts(); 
            break;
        }
      } catch (error) {
        console.error("Error in data fetch:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [accountType, profile?.superAdminId, profile?.branchId]);

  // console.log("cusotmer",selectedAccount)
  /* ================= FETCH TRANSACTIONS ================= */
  const fetchTransactions = useCallback(async () => {
    if (!selectedAccount?.id) return;

    try {
      setLoading(true);
      setError("");

      const res = await axios.get(
        `${API_URL}/all-saving-account/transaction-all`,
        {
          params: {
            accountId: selectedAccount.id,
            accountType: accountType,
          },
        },
      );
      // console.log("saving transactions",res.data)
      // let data = res.data?.statement ?? [];

      // if (fromDate) {
      //   data = data.filter(
      //     (txn) => new Date(txn.txnDate) >= new Date(fromDate)
      //   );
      // }

      // if (toDate) {
      //   data = data.filter(
      //     (txn) => new Date(txn.txnDate) <= new Date(toDate)
      //   );
      // }

      // setTransactions(data);
      setTransactions(res.data?.statement ?? []);
    } catch (err) {
      console.error("Transaction fetch error:", err);
      setError(err?.response?.data?.message || "Failed to fetch transactions");
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  }, [selectedAccount?.id, accountType]);

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedAccount) {
      toast.warn("Please select Saving Account");
      return;
    }

    if (fromDate && toDate && fromDate > toDate) {
      toast.warn("From Date cannot be greater than To Date");
      return;
    }

    fetchTransactions();
  };

  const handleDownloadPDF = async () => {
    if (!selectedAccount || transactions.length === 0) {
      toast.warn("No transactions to download");
      return;
    }

    const element = document.querySelector(".passbook-print-area");

    if (!element) {
      toast.warn("Passbook area not found");
      return;
    }

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
    });

    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let y = 0;

    // Agar content page se bada ho
    if (imgHeight > pageHeight) {
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "JPEG", 0, y, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
    } else {
      pdf.addImage(imgData, "JPEG", 0, y, imgWidth, imgHeight);
    }

    pdf.save(`Transaction_Statement_${selectedAccount.accountNumber}.pdf`);
  };

  // secure mobile number
  const maskMobile = (mobile = "") =>
    mobile.length >= 4 ? mobile.replace(/\d(?=\d{4})/g, "X") : "--";

  const getAccountLabel = (acc) => {
    if (!acc) return "";

    const name = acc.customerName || acc?.customer?.fullName || "--";

    const number = acc.accountNumber || acc.accountNo || "--";

    return `${name} | ${number}`;
  };

  return (
    <div className="transaction-report-container">
      <h1 className="transaction-report-heading">Transaction Report</h1>

      {/* ================= FILTER ================= */}
      <div className="transaction-report-filter-container">
        <form
          className="transaction-report-filter-form"
          onSubmit={handleSubmit}
        >
          <div className="transaction-report-filter-form-section">
            <div className="transaction-report-filter-form-input-fields">
              <label>Account Type</label>
              <select
                value={accountType}
                onChange={(e) => setAccountType(e.target.value)}
              >
                <option value="">Select Account</option>
                {["SAVING", "RD", "DD", "MIS"].map((acc) => (
                  <option key={acc} value={acc}>
                    {acc}
                  </option>
                ))}
              </select>
            </div>

            {/* <div className="transaction-report-filter-form-input-fields">
              <label>Saving Account</label>
              <select
                value={selectedAccount?.id || ""}
                onChange={(e) => {
                  const acc = savingAccounts.find(
                    (a) => a.id === Number(e.target.value)
                  );
                  setSelectedAccount(acc || null);
                }}
              >
                <option value="">Select Account</option>
                {savingAccounts.map((acc) => (
                  <option key={acc.id} value={acc.id}>
                    {acc.customerName} | {acc.accountNumber}
                  </option>
                ))}
              </select>
            </div> */}

            {/* <div className="transaction-report-filter-form-input-fields">
              <label>{accountType} Account</label>

              <Select
                className="account-select-container"
                classNamePrefix="account-select"
                placeholder="Search by Name or A/C No..."
                isSearchable
                options={savingAccounts.map((acc) => ({
                  value: acc.id,
                  label: `${acc.customerName} | ${acc.accountNumber || acc.accountNo ||acc?.customer?.fullName | acc?.accountNumber}`,
                  account: acc
                }))}
                value={
                  selectedAccount
                    ? {
                        value: selectedAccount.id,
                        label: `${selectedAccount.customerName} | ${selectedAccount.accountNumber || selectedAccount.accountNo}`,
                        account: selectedAccount
                      }
                    : null
                }
                onChange={(selected) => setSelectedAccount(selected?.account || null)}
              />
            </div> */}

            <div className="transaction-report-filter-form-input-fields">
              <label>{accountType} Account</label>
              <Select
                className="account-select-container"
                classNamePrefix="account-select"
                placeholder="Search by Name or A/C No..."
                isSearchable
                options={savingAccounts.map((acc) => ({
                  value: acc.id,
                  label: getAccountLabel(acc), 
                  account: acc,
                }))}
                value={
                  selectedAccount
                    ? {
                        value: selectedAccount.id,
                        label: getAccountLabel(selectedAccount), 
                        account: selectedAccount,
                      }
                    : null
                }
                onChange={(selected) =>
                  setSelectedAccount(selected?.account || null)
                }
              />
            </div>

            <div className="transaction-report-filter-form-input-fields">
              <label>From Date</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="transaction-report-filter-form-input-fields">
              <label>To Date</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>

          <button
            type="submit"
            className="transaction-report-filter-form-submit-btn"
            disabled={loading}
          >
            {loading ? "Loading..." : "Get Records"}
          </button>
        </form>
      </div>

      {/* ================= ACTION BUTTONS ================= */}
      <div className="transaction-report-download-btns">
        <button
          className="print-btn"
          onClick={handleDownloadPDF}
          disabled={!transactions.length}
        >
          Download Statement (PDF)
        </button>

        <button
          className="print-btn"
          onClick={() =>
            navigate("/Transaction/ViewStatement", {
              state: { selectedAccount, transactions, profile },
            })
          }
          disabled={!transactions.length}
        >
          Print Statement
        </button>
      </div>

      {/* ================= TRANSACTION TABLE ================= */}
      <div className="transaction-report-table-container">
        {error && <p className="error-text">{error}</p>}

        <table className="transaction-report-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Customer ID</th>
              <th>Account No</th>
              <th>Txn Type</th>
              <th>Interest Amount</th>
              <th>Payment Mode</th>
              <th>Current Balance</th>
              <th>Date</th>
              <th>Narration</th>
              {/* <th>Status</th> */}
            </tr>
          </thead>
          <tbody>
            {transactions.length ? (
              transactions.map((txn, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{txn.customerId}</td>
                  <td>{selectedAccount.accountNo||selectedAccount?.accountNumber}</td>
                  <td>{txn.txnType}</td>
                  <td>₹{txn.amount}</td>
                  <td>{txn.paymentMode}</td>
                  <td>₹{txn.balanceAfterTxn}</td>
                  <td>
                    {txn.txnDate
                      ? new Date(txn.txnDate).toLocaleDateString("en-GB")
                      : "-"}
                  </td>
                  <td>{txn.remarks || "-"}</td>
                  {/* <td>{txn.status}</td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" align="center">
                  {loading ? "Loading..." : "No records found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ================= PASSBOOK (PDF SOURCE) ================= */}
      <div className="passbook-print-area">
        <div className="passbook-print-company-details">
          <div className="company-logo">
            <img src={company?.logoUrl} alt="company-logo" />
          </div>
          <div className="company-info">
            <h3>{company?.name}</h3>
            <p>
              CIN: <span>{company?.cin || "--"}</span>
            </p>
            <p>
              Address: <span>{company?.address || "--"}</span>
            </p>
            <p>
              Email: <span>{company?.email || "--"}</span>
            </p>
          </div>
        </div>

        <div className="passbook-customer-branch-details">
          <div className="passbook-customer-details">
            <h3>Customer Details</h3>
            <div className="passbook-customer-info">
              <p>
                Account No: <span>{selectedAccount?.accountNumber}</span>
              </p>
              <p style={{ fontSize: "16px", fontWeight: "600" }}>
                {selectedAccount?.customerName}
              </p>
              <p>Customer Address: {selectedAccount?.address || "--"}</p>
              <p>Mobile: {maskMobile(selectedAccount?.mobileNumber)}</p>
            </div>
          </div>
          <div className="passbook-branch-details">
            <h3>Branch Details</h3>
            <div className="passbook-branch-info">
              <p>
                Branch Id: <span>{branch?.id}</span>
              </p>
              <p>Branch Name: {branch?.name}</p>
              <p>Branch Address: {branch?.address}</p>
              <p>Branch City: {branch?.city}</p>
              <p>Branch Code: {branch?.code}</p>
              <p>Branch State: {branch?.state}</p>
              <p>Branch Country: {branch?.country}</p>
              <p>Branch Contact: {branch?.phone}</p>
            </div>
          </div>
        </div>

        <div className="passbook-statement-period">
          <h3>
            Statement Period: {fromDate} to {toDate}
          </h3>
        </div>
        <table className="passbook-table">
          <thead>
            <tr>
              {/* <th>Date</th>
              <th>Particulars</th>
              <th>Debit</th>
              <th>Credit</th>
              <th>Balance</th> */}
              <th>SN</th>
              {/* <th>Customer ID</th>
              <th>Account No</th> */}
              <th>Txn Type</th>
              <th>Interest Amount</th>
              <th>Payment Mode</th>
              <th>Current Balance</th>
              <th>Date</th>
              <th>Narration</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((txn, i) => (
              <tr key={i}>
                {/* <td>{new Date(txn.txnDate).toLocaleDateString()}</td>
                <td>{txn.txnType}</td>
                <td className={txn.txnType === "WITHDRAW" ? "debit" : ""}>
                  {txn.txnType === "WITHDRAW" ? "₹" + txn.amount : "-"}
                </td>

                <td className={txn.txnType === "DEPOSIT" ? "credit" : ""}>
                  {txn.txnType === "DEPOSIT" ? "₹" + txn.amount : "-"}
                </td>

                <td className="balance">{"₹" + txn.balanceAfterTxn}</td> */}
                <td>{i + 1}</td>
                  {/* <td>{txn.customerId}</td>
                  <td>{selectedAccount.accountNo||selectedAccount?.accountNumber}</td> */}
                  <td>{txn.txnType}</td>
                  <td>₹{txn.amount}</td>
                  <td>{txn.paymentMode}</td>
                  <td>₹{txn.balanceAfterTxn}</td>
                  <td>
                    {txn.txnDate
                      ? new Date(txn.txnDate).toLocaleDateString("en-GB")
                      : "-"}
                  </td>
                  <td>{txn.remarks || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionReport;
